import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';

/**
 * Blocks the agency registration route once the instance is already onboarded
 * (an AGENCY user exists). Redirects to /login in that case. On a lookup error
 * we fail open (allow), so a transient backend issue can't lock onboarding out.
 */
export const onboardingGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.onboardingStatus().pipe(
    map((res: any) => (res?.onboarded ? router.parseUrl('/login') : true)),
    catchError(() => of(true))
  );
};
